import { Pipe, PipeTransform } from "@angular/core";
import { AccountService } from "@modules/account/services/account.service";
import { FiatPrecisionSymbolPipe } from "@modules/core/pipes/currency.symbol.precision.pipe";
import { PercentSymbolPipe } from "@modules/core/pipes/percent-symbol.pipe";

@Pipe({
	name: "percent_precision",
	standalone: false
})
export class PercentagePrecisionPipe implements PipeTransform {
	constructor(
		private fiatPrecisionPipe: FiatPrecisionSymbolPipe,
		private percentSymbolPipe: PercentSymbolPipe,
		private accountService: AccountService
	) {}

	public transform(value: string | number, customPrecision: number = 2, cutZeroSuffix: boolean = true): string {
		const fiat = this.accountService.getDefaultFiat();

		const fiatPrecisionValue = this.fiatPrecisionPipe.transform(value, {
			currencies: [fiat],
			customPrecision: customPrecision,
			cutZeroSuffix: cutZeroSuffix,
			cutAllZeroSuffix: true,
			symbol: false
		});

		return this.percentSymbolPipe.transform(fiatPrecisionValue);
	}
}
